import { createSlice } from '@reduxjs/toolkit';
import { parseJwt } from '../service/AuthService';


const userSlice = createSlice({
    name: 'user',
    initialState: {
        data: null, // Initially, no user is logged in
        roles: [], // List of roles decoded from the token
    },
    reducers: {
        setUser: (state, action) => {
            console.log('setUser', action.payload);
            state.data = action.payload; // Store the user object after login

            const decodedToken = parseJwt(action.payload.authenticationToken);
            state.roles = decodedToken?.roles || []; // Save roles or an empty array if not found
        },
        clearUser: (state) => {
            state.data = null; // Clear the user data on logout
            state.roles = []; // Clear the roles on logout
        },
    },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;

